import React from 'react';

const Signin = React.lazy(
  () => import('../../../modules/auth/Signin/Signin'),
);
const ForgotPassword = React.lazy(
  () => import('../../../modules/auth/ForgetPassword/ForgetPasswordJwtAuth'),
);
const ResetPassword = React.lazy(
  () => import('../../../modules/auth/ForgetPassword/ResetPassword'),
);
export const authRouteConfig = [
  {
    path: '/signin',
    element: <Signin />,
  },
  {
    path: '/forgot/send-mail',
    element: <ForgotPassword />,
  },
  {
    path: '/forgot/config-new-password',
    element: <ResetPassword />,
  },
];
